"use client";

import React, { useState, useEffect } from "react";

import useProtocol from "@/hooks/api/useProtocol";
import useProtocolVaults from "@/hooks/api/useProtocolVaults";
import { SupLoader } from "@repo/core-ui";
import VaultMain from "@/components/Vault/Main";

export default function ProtocolVaultsPage({ params: { slug } }: { params: { slug: string } }) {
  const [protocolId, setProtocolId] = useState<string | undefined>(undefined);

  // @ts-ignore
  const { data: name, isLoading: nameLoading } = useProtocol(slug);
  const { data: protocolVaults } = useProtocolVaults(protocolId, nameLoading);

  useEffect(() => {
    if (name && !nameLoading) {
      setProtocolId(name.id);
      return;
    }
  }, [name, nameLoading]);

  return protocolVaults === undefined ? (
    <SupLoader />
  ) : (
    <VaultMain className="min-h-fit pt-6 md:min-h-0" filterVaults={protocolVaults.length > 0 ? protocolVaults : ["empty"]} hideColumns={["protocol"]} />
  );
}
